import { createContext as e, useContext as t } from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/table/primitive/selection-actions-context.tsx
var r = e({}), i = ({ children: e, onClearSelection: t, onSelectAll: i }) => /* @__PURE__ */ n(r.Provider, {
	value: {
		onClearSelection: t,
		onSelectAll: i
	},
	children: e
}), a = () => t(r);
//#endregion
export { i as TableSelectionActionsProvider, a as useTableSelectionActions };
